import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
// import { DoctorViewComponent } from './doctor-view.component';

@Injectable({
  providedIn: 'root'
})
export class DoctorViewService {

    private subject = new Subject<any>();
    constructor(public router:Router){}

    sendMessage(message: string) {
        this.subject.next(message);
        this.router.navigateByUrl("/Doctor");
        message == null;
    }

    clearMessages() {
        this.subject.next();
    }

    getMessage(): Observable<any> {
        return this.subject.asObservable();
    }
// for medical and diagnosis prescription scroll fuction
    private _listners = new Subject<any>();

    listen(): Observable<any> {
       return this._listners.asObservable();
    }

    filter(filterBy: string) {
       this._listners.next(filterBy);
    }
}
